import React, { Suspense, useState, useEffect } from 'react'
import ErrorView from './Error'
import Spinner from './Loading'
import { normalizeSessionData, loadSession } from './App.utils.js'
import PdfjsViewer from './viewers/pdfjs'

export default function App({ accessToken, locale }) {
  const [isLoading, setIsLoading] = useState(true)
  const [appState, setAppState] = useState({})
  const [error, setError] = useState(null)

  useEffect(() => {
    try {
      loadSession(accessToken)
        .then((data) => {
          setAppState(normalizeSessionData(data))
          setIsLoading(false)
        })
        .catch((error) => {
          console.error(error)
          setError(error)
        })
    } catch (err) {
      console.log(err)
      setError(err)
    }
  }, [accessToken])

  if (!accessToken || error != null) {
    return <ErrorView errorMessage={error && error.message} />
  }

  if (isLoading) {
    return <Spinner />
  }

  return (
    <Suspense fallback={<Spinner />}>
      <PdfjsViewer locale={locale} session={appState} sessionId={accessToken} />
    </Suspense>
  )
}
